import { Box, TextNew } from '@jfs/ui-new'
import { ImageBackground, ScrollView } from 'react-native'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { SvgImage } from '../SvgImage'
import styles from './styles'
import { CarousalItemProp } from './types'

const CarousalItem = (props: CarousalItemProp) => {
  const { data, onPress, isLarge, isFromProfile } = props
  const { heading } = data
  return (
    <Box
      {...styles.itemContainer(isLarge, isFromProfile)}
      onPress={onPress}
      testID="carousalItem"
      underlayColor={'TRANSPARENT'}>
      <>
        {data.image && (
          <ScrollView bounces={false} >
          <ImageBackground
            style={styles.imageStyle(isLarge, isFromProfile)}
            imageStyle={styles.curvedImageStyle}
            source={{ uri: data?.image }}>
            <Box {...styles.playContainer}>
              <SvgImage imageName={'PlayIcon'} height={48} width={48} />
            </Box>
          </ImageBackground>
          </ScrollView>
        )}
        <ModBox show={heading !== undefined && heading !== '' && isFromProfile} pt={16} pb={12}>
          <TextNew numberOfLines={3} type={'body14'} weight={'dense'}>
            {heading}
          </TextNew>
        </ModBox>
      </>
    </Box>
  )
}

export default CarousalItem
